module.exports = __webpack_public_path__ + "img/weddings.a5cf5007.jpg";